import {NgModule} from '@angular/core';
import {HttpClientModule} from "@angular/common/http";
import {ReactiveFormsModule} from "@angular/forms";
import {MatFormFieldModule} from "@angular/material/form-field";
import {MatSelectModule} from "@angular/material/select";
import {CommonModule} from "@angular/common";
import {BonificoSepaComponent} from "./components/bonifico-sepa/bonifico-sepa.component";
import {TranslateModule} from "../translate/translate.module";
import {MatInputModule} from "@angular/material/input";
import {MatRadioModule} from "@angular/material/radio";
import {InfoTipModule} from "../info-tip/info-tip.module";
import {NgxsFormPluginModule} from "@ngxs/form-plugin";
import {EstremiPersonaFisicaComponent} from "./components/estremi-persona-fisica/estremi-persona-fisica.component";
import {MatDatepickerModule} from "@angular/material/datepicker";
import {MatCheckboxModule} from "@angular/material/checkbox";
import {BonificoExtraSepaComponent} from './components/bonifico-extra-sepa/bonifico-extra-sepa.component';
import {VagliaBdiComponent} from './components/vaglia-bdi/vaglia-bdi.component';
import {IndirizzoPagamentoComponent} from './components/indirizzo-pagamento/indirizzo-pagamento.component';
import {MatExpansionModule} from '@angular/material/expansion';
import {DatiResidenzaComponent} from './components/dati-residenza/dati-residenza.component';

@NgModule({
	declarations: [
		BonificoSepaComponent,
		EstremiPersonaFisicaComponent,
		BonificoExtraSepaComponent,
		VagliaBdiComponent,
		IndirizzoPagamentoComponent,
		DatiResidenzaComponent
	],
	imports: [
		CommonModule,
		HttpClientModule,
		ReactiveFormsModule,
		NgxsFormPluginModule,
		MatFormFieldModule,
		MatSelectModule,
		TranslateModule,
		MatInputModule,
		MatRadioModule,
		InfoTipModule,
		MatDatepickerModule,
		MatCheckboxModule,
		MatExpansionModule
	],
	exports: [
		BonificoSepaComponent,
		EstremiPersonaFisicaComponent,
		BonificoExtraSepaComponent,
		VagliaBdiComponent,
		IndirizzoPagamentoComponent
	],
	providers: []
})
export class ModalitaPagamentoModule {
}
